const CLOCK_COLOUR_PATH =
  "IMAGE*__SKY_SPORTS/TEAM_ELEMENTS/UNIVERSAL/TEAM_COLOURS/";

export class ScoresByQuarterMini {
  constructor({
    animate,
    preview,
    update,
    animateOff,
    getVizPage,
    updateVizPage,
  }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.getVizPage = getVizPage;
    this.updateVizPage = updateVizPage;
    this.name = "ScoreQBQMini";
    this.scene = "ScoreQBQMini";
    this.data = [];
    this.page = 10003;
  }

  async preview({ options }) {
    this.onAir = false;
    this.options = options;
    let xml = await this.getVizPage({ page: this.page });

    xml.payload.field.find((item) => {
      return item.attr.name === "102"; // Number
    }).value =
      CLOCK_COLOUR_PATH +
        options.game?.home_team?.variables?.[options.homeKit + "_clock_bg"] ||
      "";

    xml.payload.field.find((item) => {
      return item.attr.name === "103"; // Number
    }).value =
      CLOCK_COLOUR_PATH +
        options.game?.home_team?.variables?.[options.homeKit + "_clock_text"] ||
      "";

    xml.payload.field.find((item) => {
      return item.attr.name === "108"; // Number
    }).value =
      CLOCK_COLOUR_PATH +
        options.game?.away_team?.variables?.[options.awayKit + "_clock_bg"] ||
      "";

    xml.payload.field.find((item) => {
      return item.attr.name === "109"; // Number
    }).value =
      CLOCK_COLOUR_PATH +
        options.game?.away_team?.variables?.[options.awayKit + "_clock_text"] ||
      "";

    xml.payload.field.find((item) => {
      return item.attr.name === "0101"; // Number
    }).value = options.game?.scores_by_quarter?.home?.first;
    xml.payload.field.find((item) => {
      return item.attr.name === "0102"; // Number
    }).value = options.game?.scores_by_quarter?.away?.first;
    xml.payload.field.find((item) => {
      return item.attr.name === "0201"; // Number
    }).value = options.game?.scores_by_quarter?.home?.second;
    xml.payload.field.find((item) => {
      return item.attr.name === "0202"; // Number
    }).value = options.game?.scores_by_quarter?.away?.second;
    xml.payload.field.find((item) => {
      return item.attr.name === "0301"; // Number
    }).value = options.game?.scores_by_quarter?.home?.third;
    xml.payload.field.find((item) => {
      return item.attr.name === "0302"; // Number
    }).value = options.game?.scores_by_quarter?.away?.third;
    xml.payload.field.find((item) => {
      return item.attr.name === "0401"; // Number
    }).value = options.game?.scores_by_quarter?.home?.fourth;
    xml.payload.field.find((item) => {
      return item.attr.name === "0402"; // Number
    }).value = options.game?.scores_by_quarter?.away?.fourth;
    xml.payload.field.find((item) => {
      return item.attr.name === "0501"; // Number
    }).value = options.game?.scores_by_quarter?.home?.goals;
    xml.payload.field.find((item) => {
      return item.attr.name === "0502"; // Number
    }).value = options.game?.scores_by_quarter?.away?.goals;

    await this.updateVizPage({ page: this.page, data: xml });
    this.sendPreview("page:read " + this.page);
  }

  animate({ options }) {
    this.onAir = true;
    this.sendAnimate({ page: this.page });
  }
  animateOff({ options }) {
    clearTimeout(this.to);
    this.onAir = false;
    this.sendAnimateOff({ page: this.page });
  }
}
